import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { configsSelector } from '../../store/reducers/servicesConfigs';
import * as Service from '../../server/RestClients';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1px solid #a9a9a9',
    borderRadius: 4,
    width: 'fit-content',
    justifySelf: 'center',
  },
  tableContainer: {
    maxHeight: 500,
  },
  bold: {
    marginBottom: theme.spacing(2),
    fontWeight: 700,
  },
  input: {
    // margin: theme.spacing(2),
  },
  blueButton: {
    marginTop: theme.spacing(2),
    backgroundColor: '#2ca0f7',
    color: 'white',
    textTransform: 'none',
    fontFamily: 'Exo 2',
  },
  select: {
    margin: theme.spacing(2),
    minWidth: 300,
  },
}));

export default () => {
  const classes = useStyles();
  const configs = useSelector(configsSelector);

  const configOptions = configs.map(({ host, port }) => `${host}:${port}`);

  const { handleSubmit, control, errors } = useForm();

  const history = useHistory();

  const onSubmit = handleSubmit((values) => {
    const { accountToken } = values;
    Service.loginAll(accountToken);
    history.push('/', { loggedIn: true });
  });

  return {
    configOptions,
    classes,
    control,
    errors,
    onSubmit,
  };
};
